export default __webpack_public_path__ + "static/global-adviser-alpha-david-large-1cdf8c81b293d2554e5924830eb32c69.png";